import { Badge, BadgeProps } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import {
  StatusGetInstances,
  StatusGetInstancesLabel,
} from '@/service/one-click-deploy/type';
import { LoaderCircle } from 'lucide-react';

type Props = {
  status: StatusGetInstances;
} & BadgeProps;
const BadgeStatus = ({ className, status, ...props }: Props) => {
  return (
    <Badge
      variant={'secondary'}
      className={cn(
        'text-blue-500',
        status === StatusGetInstances.Initial &&
          'bg-purple-500/10 text-purple-500',
        status === StatusGetInstances.Running && 'bg-success/10 text-success',
        status === StatusGetInstances.Allocate && 'bg-warning/10 text-warning',
        status === StatusGetInstances.Terminated &&
          'bg-destructive/10 text-destructive',
        status === StatusGetInstances.Failed &&
          'bg-destructive/10 text-destructive',
        className
      )}
      {...props}
    >
      {[StatusGetInstances.Initial, StatusGetInstances.Allocate].includes(status) && (
        <LoaderCircle className="h-3 w-3 animate-spin mr-0.5" />
      )}
      {StatusGetInstancesLabel?.[status] || status}
    </Badge>
  );
};

export default BadgeStatus;
